import styled from 'styled-components';

export const FormGroupWrap = styled.div`
  margin-bottom: ${props => props.mb};
  text-align: ${props => props.textalign};
`;
